export default "__VITE_ASSET__64e27768__"